// components/steps/UniversityStep.tsx
import React, { useState, useEffect } from 'react';
import { api } from '../../config/api.ts';
import { University } from '../../types';
import { AutocompleteInput } from '../ui/AutocompleteInput.tsx';
import { ModernCard } from '../ui/ModernCard.tsx';
import { SearchIcon } from '../icons/index.tsx';

interface UniversityStepProps {
  onSelect: (university: University) => void;
  setError: (error: string) => void;
  setLoading: (loading: boolean) => void;
}

export const UniversityStep: React.FC<UniversityStepProps> = ({ 
  onSelect, 
  setError, 
  setLoading 
}) => {
  const [universities, setUniversities] = useState<University[]>([]);
  const [universitySearch, setUniversitySearch] = useState('');

  useEffect(() => {
    loadUniversities();
  }, []);

  const loadUniversities = async () => {
    try {
      setLoading(true);
      const response = await api.get('/public/universities');
      if (response.data.success) {
        setUniversities(response.data.data);
      }
    } catch (err) {
      setError('فشل في تحميل الجامعات');
    } finally {
      setLoading(false);
    }
  };

  const filteredUniversities = universities.filter(university =>
    university.name.toLowerCase().includes(universitySearch.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">اختر الجامعة</h2>
        <p className="text-gray-600">اختر جامعتك للبدء</p>
      </div>
      
      <AutocompleteInput
        label="البحث في الجامعات"
        placeholder="اكتب للبحث في الجامعات..."
        value={universitySearch}
        onChange={setUniversitySearch}
        onSelect={onSelect}
        options={filteredUniversities}
        displayKey="name"
        icon={<SearchIcon />}
      />

      <div className="space-y-3">
        <h3 className="font-medium text-gray-700">الجامعات المتاحة</h3>
        {filteredUniversities.slice(0, 5).map(university => (
          <ModernCard 
            key={university.university_id}
            className="p-4 cursor-pointer"
            onClick={() => onSelect(university)}
            hover
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-gray-900">{university.name}</span>
              <svg className="w-5 h-5 text-gray-400 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </div>
          </ModernCard>
        ))}
      </div>
    </div>
  );
};